// extracted by mini-css-extract-plugin
module.exports = {"resources":"resources_resources__1Vs8m","content":"resources_content__1-_Bd","fadeOut":"resources_fadeOut__3Abrh","fadeIn":"resources_fadeIn__3ZFtP"};